import { useEffect, useCallback, useState } from 'react';

import { Box, Grid, Button, CircularProgress, FormControlLabel, Checkbox, TablePagination } from '@mui/material';
import { SelectField, TextField, DateTimePicker, MultilineField, Dialog } from 'style-guide';

import { STATUS } from 'constants/global-constants';
import { REQUEST_ACTIONS, sendRequest, setOrderData } from 'utils/Communicator';

import { useDispatch, useSelector } from 'react-redux';
import { getOrders } from 'reducers/order-reducers/ordersSlicer';
import { snackbarToggle } from 'reducers/snackbarSlicer';
import { Select } from 'element-react';
import * as XLSX from 'xlsx';

const CustomsUIIHSCodes = ({ data, index, updateData, saveCustomsUIData }) => {
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);

    const [invoiceOptions, setInvoiceOptions] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [totalCost, setTotalCost] = useState(0);
    const [selectedInvoice, setSelectedInvoice] = useState(1);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [codes, setCodes] = useState([]);
    const [selectedInvoiceName, setSelectedInvoiceName] = useState("ALL");
    const [shipper, setShipper] = useState("");
    const [consignee, setConsignee] = useState("");

    const updateCode = (cdss, code, cost, quantity) => {
        var cds = JSON.parse(JSON.stringify(cdss));
        var exists = false;
        var total_items = 0;
        var total_cost = 0;
        for (var i = 0; i < cds.length; i++) {
            if (cds[i].hscode == code) {
                exists = true;
                cds[i].totalCost += cost;
                cds[i].qty += quantity;
            }
            total_items += cds[i].qty;
            total_cost += cds[i].totalCost;
        }
        if (!exists) {
            cds.push({
                hscode: code,
                totalCost: cost,
                qty: quantity,
                itemsP: 0,
                costP: 0,
            })
        }
        for (var i = 0; i < cds.length; i++) {
            cds[i].itemsP = 100*cds[i].qty/total_items
            cds[i].costP = 100 * cds[i].totalCost / total_cost
        }
        setTotalItems(total_items);
        setTotalCost(total_cost);
        return cds;
    }

    const resetFilter = (selection) => {
        var list = data?.productData?.filter(f => filterFun(f, selection));
        var cds = [];
        for (var i = 0; i < list?.length; i++) {
            var code = list[i].hscode ? list[i].hscode : (list[i].hs_code ? list[i].hs_code : null);
            if(code)
                cds = updateCode(cds, code, list[i].total_value, list[i].quantity);
        }
        var total_items = 0;
        var total_cost = 0;
        for (var i = 0; i < cds.length; i++) {
            total_items += cds[i].qty;
            total_cost += cds[i].totalCost;
        }
        setTotalItems(total_items);
        setTotalCost(total_cost);
        setCodes(cds);
    }

    useEffect(() => {
        var invs = [];
        invs.push({id: 1, name: "ALL"});
        if (data?.aiData?.file_validation) {
            if (data?.aiData?.file_validation?.invoices) {
                for (var i = 0; i < data.aiData.file_validation.invoices.length; i++) {
                    var dt = {};
                    dt.id = i+2;
                    dt.name = data.aiData.file_validation.invoices[i].document_ref;
                    invs.push(dt);
                }
            }
        }
        setInvoiceOptions(invs);
        setInvoices(data.productData);
        resetFilter("ALL");
    }, [data]);
    
    const filterFun = (data, name) => {
        if (name === "ALL")
            return true;
        console.log(data.product)
        if (data.invoice_number) {
            if (data.invoice_number === name)
                return true;
        }
        return false;
    }
    const jsonToExcel = function (data, name, header) {
        var ws = XLSX.utils.json_to_sheet(data, header);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "All");
        XLSX.writeFile(wb, name + ".xlsx");
    }

    const exportCSV = () => {
        var data_main = [];
        var header = [];
        for (var i = 0; i < codes.length; i++) {
            var data = {
                "HS Code": codes[i].hscode,
                "Total Cost": Number(codes[i].totalCost).toFixed(2),
                "Quantity": codes[i].qty,
                /*"Items %": Number(codes[i].itemsP).toFixed(2),
                "Cost %": Number(codes[i].costP).toFixed(2)*/
            };
            data_main.push(data);
        }
        jsonToExcel(data_main, "HSCodes", header);
    }
    const getInvoiceName = () => {
        if (selectedInvoiceName === "ALL") {
            return invoiceOptions[1]?.name || selectedInvoiceName;
        }
        return selectedInvoiceName;
    }
    return (
        <>
            <Grid item container style={{ marginBottom: "10px", width: "92vw" }} alignItems="center">
                <SelectField
                    label='Invoice' 
                    lg={2}
                    value={selectedInvoice}
                    onChange={event => {
                        setSelectedInvoice(event.target.value);
                        var sel = invoiceOptions.find(f => f.id == event.target.value);
                        setSelectedInvoiceName(sel?.name);
                        if (sel?.name) {
                            resetFilter(sel?.name);
                        }
                    }}
                    options={invoiceOptions}
                />
                <TextField
                    lg={2.8}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Shipper'
                    value={data?.aiData?.file_validation?.invoices?.find(f => f.document_ref === getInvoiceName())?.fields?.find(f => f.field === "shipper_name")?.value}
                />
                <TextField
                    lg={2.8}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Consignee'
                    value={data?.aiData?.file_validation?.invoices?.find(f => f.document_ref === getInvoiceName())?.fields?.find(f => f.field === "consignee_name")?.value}
                />
                <TextField
                    lg={0.6}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Currency'
                    value={data?.aiData?.file_validation?.invoices?.find(f => f.document_ref === getInvoiceName())?.fields?.find(f => f.field === "currency")?.value}
                />
                <TextField
                    lg={1}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Total Items'
                    value={totalItems}
                />
                <TextField
                    lg={1}
                    style={{ padding: "5px" }}
                    type="Text"
                    label='Total Cost'
                    value={totalCost}
                />
                {<Button
                    variant='contained'
                    style={{ margin: "15px", maxWidth: "150px" }}
                    onClick={exportCSV}>
                    Export Codes
                </Button>}
            </Grid>
            <div style={{ height: "500px", overflowY: "auto", display: "block", width: "1300px" }}>
                <Grid item container style={{ border: "1px grey solid", borderRadius: "5px", maxHeight: "500px", display: "block", overflowY: "auto" }}>
                    <table style={{ width: "100%", textAlign: "left" }}>
                        <thead>
                            <tr>
                                <th style={{ borderBottom: "1px solid grey" }}>
                                    HS Code
                                </th>
                                <th style={{ borderBottom: "1px solid grey" }}>
                                    Total Items
                                </th>
                                <th style={{ borderBottom: "1px solid grey" }}>
                                    Total Cost
                                </th>
                                {/*<th style={{ borderBottom: "1px solid grey" }}>
                                    Item %
                                </th>
                                <th style={{ borderBottom: "1px solid grey" }}>
                                    Cost %
                                </th>*/}
                            </tr>
                        </thead>
                        <tbody>
                            {codes?.map((cd, ind) => (
                                <tr key={ind}>
                                    <td>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={cd.hscode}
                                        />
                                    </td>
                                    <td>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={cd.qty}
                                        />
                                    </td>
                                    <td>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={Number(cd.totalCost).toFixed(2)}
                                        />
                                    </td>
                                    {/*<td>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={Number(cd.itemsP).toFixed(2)}
                                        />
                                    </td>
                                    <td>
                                        <TextField
                                            lg={12}
                                            style={{ padding: 0, margin: 0 }}
                                            type="Text"
                                            label=''
                                            value={Number(cd.costP).toFixed(2)}
                                        />
                                    </td>*/}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Grid>
            </div>
        </>
    );
}


export default CustomsUIIHSCodes;